import { MoreMenu } from "./more.menu";
import MenuItem = MoreMenu.MenuItem;
import { S25States } from "../../../services/state/state.map";
import { FlsService } from "../../../services/fls.service";
import { UserprefService } from "../../../services/userpref.service";
import { PreferenceService } from "../../../services/preference.service";
import { SettingsService } from "../../../services/settings.service";
import { AppPathsService } from "../../../services/app.paths.service";
import { MasqueradeService } from "../../../services/masquerade.service";
import { S25MasqueradeSwitchRolesComponent } from "../../S25-masquerade/masquerade.switch.roles.component";
import { S25Util } from "../../../util/s25-util";

export class MoreMenuUtil {
    public static getPreferences() {
        return PreferenceService.getPreferences([
            "config_logo_link",
            "config_feedback_email",
            "pro_dark_mode",
            "TaskHeaderCount",
        ]);
    }

    public static applyDarkModeFromPreferenceValue(darkModePreferenceValue: string | undefined): void {
        S25Util.setDarkMode(darkModePreferenceValue === "T");
    }

    public static async applyDarkModeFromUserPreference(): Promise<void> {
        const prefs = await PreferenceService.getPreferences(["pro_dark_mode"]);
        MoreMenuUtil.applyDarkModeFromPreferenceValue(prefs?.pro_dark_mode?.value);
    }

    public static async getNavigateTo(has25LiveAccess: boolean = true): Promise<MenuItem[]> {
        const fls = await FlsService.getFls();
        const isLoggedIn = await UserprefService.getLoggedIn();
        const groupId = await UserprefService.getGroupId();
        const settings = await SettingsService.getSettings();

        // If user doesn't have 25Live access, only show User Settings
        const navigateTo = has25LiveAccess
            ? [
                  S25States.typed.list,
                  S25States.typed.calendar,
                  S25States.typed.availability,
                  S25States.typed.search,
                  S25States.typed.grids,
                  S25States.typed.optimizerEffectiveDating,
                  ...(isLoggedIn && "N" !== fls.REP_LIST ? [S25States.typed.report] : []),
                  S25States.typed.publisher,
                  ...(AppPathsService.hasStudentEngagementAccess(fls, groupId, settings)
                      ? [S25States.typed.seHome]
                      : []),
                  S25States.typed.systemSettings,
                  S25States.typed.userSettings,
              ]
            : [S25States.typed.userSettings];

        return navigateTo
            .filter((item: S25States.UntypedState) => !item.isHidden)
            .map((item): MenuItem => {
                if (item.parent === "external") {
                    return { displayName: item.display, url: item.url };
                }

                return { displayName: item.display, state: item };
            });
    }

    /** Same entries as the More menu “Switch Roles” section; empty when none apply. */
    public static async getSwitchRolesMenuItems(): Promise<MenuItem[]> {
        const isLoggedIn = await UserprefService.getLoggedIn();
        if (!isLoggedIn) {
            return [];
        }
        const currentContactId = await UserprefService.getContactId();
        const roles = await MasqueradeService.getMasqueradeUsers(currentContactId);
        if (!roles?.length) {
            return [];
        }
        return [
            {
                displayName: "Switch Roles",
                dynamicValue: { component: S25MasqueradeSwitchRolesComponent },
            },
        ];
    }
}
